// Single source of truth for report "result" values (positive / negative /
// neutral) and their badge palette. Replaces the Positive/Negative/Neutral literals that
// were copy-pasted across version / prd / app report panels.

export type ReportResult = "positive" | "negative" | "neutral";

export const RESULT_PALETTE: Record<ReportResult, { label: string; color: string }> = {
  positive: { label: "正向", color: "bg-chip-green text-chip-green-foreground" },
  negative: { label: "负向", color: "bg-chip-red text-chip-red-foreground" },
  neutral: { label: "持平", color: "bg-muted text-muted-foreground" },
};

export const RESULT_OPTIONS = (Object.keys(RESULT_PALETTE) as ReportResult[]).map(
  (value) => ({ value, label: RESULT_PALETTE[value].label }),
);

// Loose lookup for wire data where `result` is an arbitrary string.
export const resultInfo = (result?: string | null) =>
  result ? (RESULT_PALETTE[result as ReportResult] ?? null) : null;
